import { datadogRum } from '@datadog/browser-rum';
import { QueryClient } from '@tanstack/react-query';

import { isRetryError } from 'common/utils/errorUtils';

const retry = (failureCount: number, error: unknown) => isRetryError(error) && failureCount < 2;

export const apiQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry,
      staleTime: 0,
    },
    mutations: {
      retry: false,
    },
  },
});

export const PERSISTED_API_QUERY_DEFAULT_CACHE_TIME = 1000 * 60 * 60; // 1 hour

export const persistedApiQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry,
      gcTime: PERSISTED_API_QUERY_DEFAULT_CACHE_TIME,
    },
    mutations: {
      onError: (error) => {
        datadogRum.addError(error, { source: 'mutation' });
      },
      retry: false,
    },
  },
});

export const getPersistedQueryClient = () => {
  return process.env.NODE_ENV !== 'test' ? persistedApiQueryClient : undefined;
};
